module.exports = {"title":"The Next Step","body":"<h2>Basically do this</h2>\n<p>yeah, a lot of this.</p>\n<h2>Then do this.</h2>\n<p>Ok? Getting the swing of things yet?</p>\n<h2>And if you’re stuck, try these things</h2>\n<ol>\n<li>first this</li>\n<li>this second</li>\n<li>if you’re really stuck, this.</li>\n<li>probably you should give up now.</li>\n</ol>\n"}


//////////////////
// WEBPACK FOOTER
// ./docs/the-next-step/index.md
// module id = 480
// module chunks = 0